// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4Amm8","toggleWrap":"styles_toggleWrap__1zzoN","content":"styles_content__16pJd","selectAreaCode":"styles_selectAreaCode__1UitH"};